import { useQuery } from '@tanstack/react-query';
import { fetchDashboardSummary } from '../api/dashboardApi';

export default function useDashboardSummary() {
    return useQuery({
        queryKey: ['dashboardSummary'],
        queryFn: fetchDashboardSummary,
        staleTime:       2 * 60 * 1000,   // 2 minutes
        refetchInterval: 5 * 60 * 1000,   // 5 minutes background poll
        placeholderData: prev => prev,     // no flash on background refetch
    });
}
